import { LightningElement, api, track } from 'lwc';
import { publicPropertyToBool } from '../../../utils/basicUtils';
import { getLabelsByLanguage } from '../../../utils/languageUtil';

const MENU_SIZES = {
    xxSmall: 'slds-dropdown_xx-small',
    xSmall: 'slds-dropdown_x-small', 
    small: 'slds-dropdown_small', 
    medium: 'slds-dropdown_medium', 
    large: 'slds-dropdown_large'
};



export default class sldsMenuPopoverMenu extends LightningElement {
    static renderMode = 'light';
    @api 
    set options(val) {
        this._options = (val ?? []).map(opt => {
            return {label: getLabelsByLanguage(opt?.label ?? ''), ...opt}
        })
    }
    get options() {
        return this._options;
    }
    
    @api set isLeft(value) {this._isLeft = publicPropertyToBool(value);} 
    get isLeft() {return this._isLeft;}

    _menuSize
    @api set menuSize(val) {this._menuSize = val;}
    get menuSize() {return this._menuSize;}

    @api value;
    @api id;
    @api set isCheck(value) {this._isCheck = publicPropertyToBool(value);}
    get isCheck() {return this._isCheck;} 

    // Send event with selectedValue to parent  --> trigger menu destruction 
    @api dispatchSelection(val) {
        console.log('and here is the val in dispatchSelection: ', val);
        if (val) {
            this.dispatchEvent(new CustomEvent('selection', {
                detail: this.id ? {id: this.id, value: val} : val,
                bubbles: true,
                composed: true
            }));
        }
    }

    // Get the selected option value && call <dispatchSelection>
    handleSelection(event) {
        const val = event.currentTarget.dataset.value;
        this.dispatchSelection(val);
    }

    // Position menu to the left or right of button
    get dropdownClass() {
        let sizeCl = '';

        if (
            this._menuSize && 
            Object.keys(MENU_SIZES).some(clKey => 
                this._menuSize === clKey || this._menuSize === MENU_SIZES[clKey]
            )
        ) {
            sizeCl = MENU_SIZES[this._menuSize] ? MENU_SIZES[this._menuSize] : this._menuSize; 
        } 

        return this.isLeft 
            ? `${sizeCl} slds-dropdown slds-dropdown_left` 
            : `${sizeCl} slds-dropdown slds-dropdown_right`;
    }

    // Add check mark to selected option if isCheckable
    get localOptions() {
        return  this.isCheck 
            ? this.options.map(opt => { 
                return {...opt, isSelected: opt.value === this.value}; }
            )
            : this.options;

    }
}